import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { IAppReduxStore } from '../../../redux/store';
import AppIcon from './AppIcon';
import { getFileTypeOrDefault } from '../../../util/FileUtils';

/**
 * Component that shows a file icon.
 */
export default ({ fileName }: IFileIconProps) => {
    if (!fileName) {
        return <></>;
    }

    /** Get relevant values from Redux store. */
    const fileTypes = useSelector((store: IAppReduxStore) => store.projectFileTypes.data);
    const fallback = useSelector((store: IAppReduxStore) => store.projectFileTypes.default);

    /** File type icons haven't been loaded yet, so stop here. */
    if (!fileTypes?.length || !fallback) {
        return <></>;
    }

    /* Determine file type. **/
    const documentFileType = useMemo(
        () => getFileTypeOrDefault(fileName),
        [fileName, fileTypes, fallback],
    );

    return (
        <AppIcon
            path={documentFileType.icon}
            color={documentFileType.color}
            size={1.25}
            tooltipPlacement='top-start'
        />
    );
};

/**
 * Interface that describes the props for a FileIcon component.
 */
export interface IFileIconProps {
    fileName: string;
}
